import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {RoadKill} from "../RoadKill";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class RoadKillIntroConfig implements GameIntroViewConfig {

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0.4, //Default 0.4
            bulletColor: 0xffffff, //Default 0xffffff

        },
        stampColor: 0xFFFFFF
    };

    stampConfig: StampConfig = {
        xSplit: true,
        volatility: Volatility.HIGH
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("introDiv", "resources/images/Intro_Divider.png");
        imgLoader.add("massiveWin", "resources/images/3x3.png");
        imgLoader.add("feature0", "resources/images/Intro_Feature_2.png");
        imgLoader.add("feature1", "resources/images/intro_feature1.png");
        imgLoader.add("feature2", "resources/images/intro_feature2.png");
        imgLoader.add("feature3", "resources/images/Intro_Feature_1.png");
        imgLoader.add("feature4", "resources/images/Intro_Feature_2.png");
        imgLoader.add("feature5", "resources/images/defaultFeature.png");
        imgLoader.add("logo", "resources/images/introLogo.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });

    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(logoSprite);

        const featureSprite0 = new PIXI.Sprite(ImgLoader.getImgTexture("feature0"));
        featureSprite0.anchor.set(0.5, 0.5);

        const featureSprite1 = new PIXI.Sprite(ImgLoader.getImgTexture("feature1"));
        featureSprite1.anchor.set(0.5, 0.5);

        const featureSprite2 = new PIXI.Sprite(ImgLoader.getImgTexture("feature2"));
        featureSprite2.anchor.set(0.5, 0.5);

        const featureSprite3: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("feature3"));
        featureSprite3.anchor.set(0.5, 0.5);

        const featureSprite4: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("massiveWin"));
        featureSprite4.anchor.set(0.5, 0.5);

        const featureSprite5: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("feature5"));
        featureSprite5.anchor.set(0.5, 0.5);

        this.pages = [];
        for (let slideShowIdx: number = 1; slideShowIdx <= 6; slideShowIdx++) {
            this.pages.push(new SlideShowPage());
        }
        this.pages[0].addChild(featureSprite0);
        this.pages[1].addChild(featureSprite1);
        this.pages[2].addChild(featureSprite2);
        this.pages[3].addChild(featureSprite3);
        this.pages[4].addChild(featureSprite4);
        this.pages[5].addChild(featureSprite5);
    }
}